// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 568 ? "b1644e8c" : chunkId) + "." + {"367":"d64ac54376a1f845","568":"2e871776c0170607","733":"1b279454ff3e6f00","950":"fa081e025a584165"}[chunkId] + ".js";
};